import { render } from "./getDisease.vue?vue&type=template&id=a757b162&scoped=true"
import script from "./getDisease.vue?vue&type=script&lang=js"
export * from "./getDisease.vue?vue&type=script&lang=js"

import "./getDisease.vue?vue&type=style&index=0&id=a757b162&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a757b162"]])

export default __exports__